import { useEffect, useMemo } from 'react';
import ReactDOM from 'react-dom';
export var Portal = function (_a) {
    var children = _a.children, _b = _a.parent, parent = _b === void 0 ? document.body : _b, className = _a.className;
    var modalWrapper = useMemo(function () { return document.createElement('div'); }, []);
    useEffect(function () {
        if (className) {
            modalWrapper.classList.add(className);
        }
        parent.appendChild(modalWrapper);
        return function () {
            parent.removeChild(modalWrapper);
        };
    }, [className, modalWrapper, parent]);
    return ReactDOM.createPortal(children, modalWrapper);
};
